import {toast} from "react-toastify"

export function SuccessToast(message) {
  return toast(message, {type: "success"})
}

export function ErrorToast(message) {
  return toast(message, {type: "error"})
}

export function InfoToast(message) {
  return toast(message, {type: "info", autoClose: 3000})
}
